import { camelCaseify } from '../../../utils'

import {
  APIHubspotFoodPartnerWithContacts,
  APIHubspotContact,
  HubspotFoodPartner,
  HubspotContact,
} from '@types'

export const pResponseHubspotFoodPartnerWithContacts = (
  data: APIHubspotFoodPartnerWithContacts,
): { foodPartner: HubspotFoodPartner; contacts: HubspotContact[] } => {
  const { foodPartner: fp, contacts: contacts } = data

  const { id, properties } = fp
  const fpData = camelCaseify(properties)

  const hungryDiscount = fpData.hungryDiscount_percentOffRetail
    ? parseFloat(fpData.hungryDiscount_percentOffRetail)
    : null

  const foodPartner: HubspotFoodPartner = {
    id,
    partnerName: fpData.partnerName,
    hungryChefId: fpData.hungryChefId,
    status: fpData.status,
    metro: fpData.metro ? fpData.metro.split(';') : [],
    addressInfo: fpData.addressInfo,
    biography: fpData.biography ? fpData.biography : null,
    linkToAdminVendorProfile: fpData.linkToAdminVendorProfile,
    cuisines: fpData.cuisines ? fpData.cuisines.split(';') : null,
    hungryDiscountPercentOffRetail: hungryDiscount,
    partnerType: fpData.partnerType ? fpData.partnerType.split(';') : null,
    companyDomainName: fpData.companyDomainName,
    description: fpData.description,
    phoneNumber: fpData.phoneNumber,
  }

  return {
    foodPartner,
    contacts: contacts.map((c: APIHubspotContact) => {
      const { id, properties } = c
      const { firstname, lastname, ...rest } = properties

      return {
        id,
        firstName: firstname,
        lastName: lastname,
        ...rest,
      }
    }),
  }
}

export const createChefFromHubspot = (
  foodPartner: HubspotFoodPartner,
  contacts: HubspotContact[] | null,
  hqId: number,
) => {
  const { id, partnerName, phoneNumber, addressInfo, biography } = foodPartner

  const chef: any = {
    firstName: partnerName,
    phoneNumber: phoneNumber,
    hubspotId: parseInt(id),
    headquarters: [],
    status: 'active',
    buildingInstructions: addressInfo || undefined,
    description: biography || '',
  }
  if (contacts) {
    chef.newContacts = contacts.map((c) => ({
      hubspotId: parseInt(c.id),
      name: `${c.firstName} ${c.lastName}`,
      email: c.email,
      phone: c.phone,
      activeHqs: `${hqId}`,
    }))
  }

  return chef
}
